import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, ElementRef, Injector } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthKey } from "./authkeys/shared/authkey.model";
import { ActionLog } from "./logging/shared/actionlog.model";
import { ErrorLog } from "./logging/shared/errorlog.model";
import { Owner } from "./owners/shared/owner.model";
import { Role } from "./owners/shared/role.model";
import { Progress } from "./progress.model";
import { TargetPreviewConfig } from "./target-preview-config.model";
import { Feature, FeatureSet, LinkData } from "./feature.model";
import { AppConfig } from "./config.service";
import { DatePipe } from "@angular/common";
import { DatasetDatapoint } from "./designer/shared/datasetdatapoint.model";
import { data } from "jquery";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";

@Injectable()
export class GlobalsService {
  public readonly MODE_SURVEY: number = 0;
  public readonly MODE_EXTERNAL_DATA: number = 1;
  public readonly MODE_SCREENCAP: number = 2;
  public readonly DTID_ALL: number = -1;

  public readonly TERMS_MODE_DEFAULT: number = 0;
  public readonly TERMS_MODE_SIMPLE: number = 1;

  //public datasetDatapoints: DatasetDatapoint[] = [];

  private activeDashboardID: number;
  private activeDatasetID: number;
  private activeDatasetIteration: number;
  private activeRespondentID: number;
  private activeRoleID: number;
  private activeTargetID: number;
  private activeBulkTargetID: string;
  private activeBulkTargetValueID: number;
  private adminUILogin: boolean;
  private allowConsoleLog: boolean;
  private allowDebug: boolean;
  private apiUrl: string;
  private apiBaseUrl: string;
  private authKey: AuthKey;
  private connected: boolean = true;
  private connectionLost: Date;
  private ccsFrom: string = "app";
  private crimecastJWTUrl: string;
  private datasetExternalID: number;
  private debug: boolean = false;
  private featureSet: FeatureSet;
  private featureSetLoaded: boolean = false;
  private featuresLoading: boolean = false;
  private globalPreview: boolean = false;
  private hideMenu: boolean;
  private impersonationMode: number = 0;
  private instanceOwnerName: string;
  private jwt: string;
  private libraryPreview: boolean = false;
  private linkData: LinkData;
  private loggedInOwnerName: string;
  private maintenance: boolean;
  private maintenanceHtml: string;
  private mode: number = this.MODE_EXTERNAL_DATA;
  private ownerID: number;
  private ownerDesignerID: string;
  private ownerKey: string;
  private ownerName: string;
  private parent: string;
  private resetPasswordToken: string;
  private respondentExternalID: number;
  private respondentID: number;
  private roleList: Role[];
  private showItems: string[];
  private showLogin: boolean;
  private simple: boolean = false;
  private standalone: boolean = true;
  private system: string;
  private targetID: number;
  private termsMode: number = this.TERMS_MODE_DEFAULT;
  private saveToastID: number;
  private isBulk: boolean = false;
  private supplierPortalV2Enabled: boolean = false;
  private modulesV2Enabled: boolean = false;

  public selectedLocMap = new Map<string, number>();

  private termsMode0 = {
    datapoint: "datapoint",
    Datapoint: "Datapoint",
    Answer: "Answer",
    answer: "answer",
    DatapointTarget: "DatapointTarget",
    datapointTarget: "datapointTarget",
    Target: "Target",
    target: "target",
  };
  /*
  private termsMode1 = {
    'datapoint': 'datapoint',
    'Datapoint': 'Datapoint',
    'Answer': 'Answer',
    'answer': 'answer',
    'DatapointTarget': 'DatapointTarget',
    'datapointTarget': 'datapointTarget',
    'Target': 'Target',
    'target': 'target'
  }*/
  private termsMode1 = {
    datapoint: "question",
    Datapoint: "Question",
    Answer: "Answer",
    answer: "answer",
    DatapointTarget: "Survey Question",
    datapointTarget: "survey question",
    Target: "Survey",
    target: "survey",
  };
  private pageSizeOptions = [50, 100, 500];

  public constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private datepipe: DatePipe,
  ) {}

  public setAppCongig(appConfig: AppConfig) {
    this.apiUrl = appConfig.ApiUrl;
    this.apiBaseUrl = appConfig.ApiBaseUrl;
    this.system = appConfig.BaseSystem;
    this.allowDebug = this.getBoolean(appConfig.AllowDebug);
    this.allowConsoleLog = this.getBoolean(appConfig.AllowConsoleLog); // handle booleans or strings
    this.supplierPortalV2Enabled = this.getBoolean(
      appConfig.SupplierPortalV2Enabled,
    );
    this.modulesV2Enabled = this.getBoolean(appConfig.ModulesV2Enabled);
    this.instanceOwnerName = appConfig.InstanceOwnerName;
    this.crimecastJWTUrl = appConfig.CrimecastJWTUrl;
  }

  async validateSelectedCcsSiteID() {
    console.log(
      `globalsService.validateSelectedCcsSiteID: Modules believes the siteID=${this.getDatasetExternalID()}`,
    );
    var key = this.newGuid();
    var message: string = `{"getSelectedSite":"${key}"}`;
    this.selectedLocMap.set(key, -1);
    this.broadcast(message, "*");

    var index = 0;
    while (++index < 100 && this.selectedLocMap.get(key) === -1) {
      await this.sleep(100);
    }

    var ccsSite = this.selectedLocMap.get(key);
    var modulesSite = this.getDatasetExternalID();
    var valid = ccsSite == modulesSite;
    console.log(`globalsService.validateSelectedCcsSiteID(): valid=${valid}`);

    this.selectedLocMap.delete(key);

    return valid;
  }

  private sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public broadcast(
    message: string,
    pathSegment: string = null,
    excludePathSegment: string = null,
  ) {
    if (
      message.startsWith('{"getSelectedSite":') ||
      message.startsWith('{"ping":')
    ) {
      var top = window.top;

      top.postMessage(message, "*");

      this.log(
        `cewm: posted ccs site id validation or keepalive message: "${message}"`,
      );
      this.log(`cewm:     from ${window.location}`);
      this.log(`cewm:     to top.`);
      return;
    }

    const menuFrameList = [];
    const frameList = window.parent.frames;

    for (let i = 0; i < frameList.length; i++) {
      try {
        const href = frameList[i].location.href;

        if (
          href.indexOf("insight") > -1 ||
          href.indexOf("externaldata") > -1 ||
          href.indexOf("localhost:4200") > -1
        ) {
          if (pathSegment === null || href.indexOf(pathSegment) > -1) {
            excludePathSegment = "reportID=-1";
            if (href.indexOf(excludePathSegment) < 0) {
              menuFrameList.push(frameList[i]);
            }
          }
        }
      } catch (err) {}
    }

    const myLoc: Location = window.location;

    //if (myLoc.indexOf('survey') > 0) {
    menuFrameList.forEach((f) => {
      try {
        const toLoc: Location = f.location;
        let canPostTo =
          myLoc.href !== toLoc.href && !this.hasMatchingReportID(myLoc, toLoc);
        if (canPostTo) {
          f.postMessage(message, "*");
          this.log(`cewm: posted window message "${message}"`);
          this.log(`cewm:     from ${myLoc}`);
          this.log(`cewm:     to ${toLoc}.`);
        }
      } catch (err) {
        this.log(`cewm: error sending window message "${message}"`);
        this.log(`cewm:     to ${f.location.href}.`);
      }
    });
    //}
  }

  private isSameBaseURL(loc1: Location, loc2: Location): boolean {
    // Compare protocol, hostname, and pathname between the two locations
    return (
      loc1.protocol === loc2.protocol &&
      loc1.hostname === loc2.hostname &&
      loc1.pathname === loc2.pathname
    );
  }

  private hasMatchingReportID(loc1: Location, loc2: Location): boolean {
    const reportView = "reports-view";
    let areReportView =
      loc1.pathname.indexOf(reportView) >= 0 &&
      loc2.pathname.indexOf(reportView) >= 0;
    if (!areReportView) return false;

    let reportID1 = this.getQueryStringValue(loc1, "reportID");
    let reportID2 = this.getQueryStringValue(loc2, "reportID");
    return reportID1 === reportID2;
  }

  private getQueryStringValue(
    location: Location,
    paramName: string,
  ): string | null {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(paramName);
  }

  public queryParamsContain(location: Location, param: string): boolean {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.has(param);
  }

  public hasReBroadcastPermission() {
    const href = window.location.href;

    let isSurveyFrame = href.indexOf("survey") > 0;
    let isSiteDetailsSideBarFrame =
      href.indexOf("reports-view") > 0 && href.indexOf("reportID=-1") > 0;
    return isSurveyFrame || isSiteDetailsSideBarFrame;
  }

  public clearActiveTarget() {
    this.setActiveTargetID(null);
    this.setActiveDatasetID(null);
    this.setActiveDatasetIteration(0);
  }

  public configOwner(externalID: number): Promise<Owner> {
    return this.http.get<Owner>("owner/config/" + externalID).toPromise();
  }

  public configureTargetPreview(
    targetID: number,
    ownerID: number = -1,
    isBulk: boolean = false,
    bulkTargetID: string = null,
  ): Promise<boolean> {
    if (this.isLibraryPreview()) {
      ownerID = this.getOwnerID();
    }
    return this.http
      .get<TargetPreviewConfig>(
        `target/preview/${targetID}?ownerID=${ownerID}&bulk=${isBulk}&bulkTargetID=${bulkTargetID}`,
      )
      .toPromise()
      .then((config) => {
        this.activeTargetID = targetID;
        this.activeDatasetID = config.datasetID;
        this.activeDatasetIteration = config.iteration;
        this.activeRespondentID = config.respondentID;
        return true;
      });
  }

  public getActiveDashboardID() {
    return this.activeDashboardID;
  }

  public getActiveDatasetID() {
    return this.activeDatasetID;
  }

  public getActiveDatasetIteration() {
    return this.activeDatasetIteration;
  }

  public getActiveRespondentID() {
    return this.activeRespondentID;
  }

  public getActiveRoleID() {
    return this.activeRoleID;
  }

  public getActiveTargetID() {
    return this.activeTargetID;
  }

  public getActiveBulkTargetID() {
    return this.activeBulkTargetID;
  }

  public getActiveBulkTargetValueID() {
    return this.activeBulkTargetValueID;
  }

  public isAdminUILogin(): boolean {
    return this.adminUILogin;
  }

  public getAnswerName() {
    return this.termsMode === 0
      ? this.termsMode0["Answer"]
      : this.termsMode1["Answer"];
  }

  public getApiUrl() {
    return this.apiUrl;
  }

  public getApiBaseUrl() {
    return this.apiBaseUrl;
  }

  public getAuthKey(): AuthKey {
    return this.authKey;
  }

  public getCCSFrom(): string {
    return this.ccsFrom;
  }

  public getConnected(): boolean {
    return this.connected;
  }

  public getCurrentURL() {
    return window.location.href;
  }

  public getDatapointName() {
    return this.termsMode === 0
      ? this.termsMode0["Datapoint"]
      : this.termsMode1["Datapoint"];
  }

  public getDatapointTargetName() {
    return this.termsMode === 0
      ? this.termsMode0["DatapointTarget"]
      : this.termsMode1["DatapointTarget"];
  }

  public getDatasetDatapointUID(datasetDatapoint: DatasetDatapoint): string {
    let lsID =
      `${this.getActiveDatasetID()}.${this.getActiveDatasetIteration()}.` +
      `${datasetDatapoint.datapointTargetID}.${datasetDatapoint.groupByValueIndex}`;
    return lsID;
  }

  public getDatasetExternalID(): number {
    return this.datasetExternalID;
  }

  public getCrimeCastUserID(): number {
    return this.respondentExternalID;
  }

  public getFeatureSet(): FeatureSet {
    return this.featureSet;
  }

  public getFeatureSetLoaded(): boolean {
    return this.featureSetLoaded;
  }

  public isGlobalPreview(): boolean {
    return this.globalPreview;
  }

  public isLibraryPreview(): boolean {
    return this.libraryPreview;
  }

  public isLinkExpired(): boolean {
    return this.featureSet?.linkData?.isExpired;
  }

  public isLocalhost(): boolean {
    return (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    );
  }

  public getHideMenu(): boolean {
    return this.hideMenu;
  }

  public getLinkExpiredHtml(): string {
    return this.featureSet.linkData.expiredHtml;
  }

  public getLinkRequiresPassword(): boolean {
    return this.featureSet?.linkData?.requiresPassword;
  }

  public getPasswordEntryHtml(): string {
    return this.featureSet?.linkData?.passwordEntryHtml;
  }

  public getMaintenance(): boolean {
    //console.log('getCCSFrom(): ' + this.getCCSFrom());
    //if (this.getCCSFrom() == null ||  this.getCCSFrom() != 'app') {
    if (this.linkData != null) {
      this.maintenance = this.linkData.maintenance;
      this.maintenanceHtml = this.linkData.maintenanceHtml;
    }
    return this.maintenance;
    //} else {
    //  return false;
    //}
  }

  public getMaintenanceHtml(): string {
    return this.maintenanceHtml;
  }

  public getImpersonationMode(): number {
    return this.impersonationMode;
  }

  public getLinkData() {
    return this.featureSet?.linkData;
  }

  public loadExpiryHtml(html: string) {
    var featureSet = new FeatureSet();
    var linkData = new LinkData();
    linkData.isExpired = true;
    linkData.expiredHtml = html;

    featureSet.linkData = linkData;
    this.setFeatureSet(featureSet);
  }

  public getCrimecastJWTUrl(): string {
    return this.crimecastJWTUrl;
  }

  public getIsBulk(): boolean {
    return this.isBulk;
  }

  public getJWT(): string {
    return this.jwt;
  }

  public getLoggedInOwnerName(): string {
    return this.loggedInOwnerName;
  }

  public getLoggedInOwnerRoleName(): string {
    if (this.roleList) {
      return this.roleList.filter((role) => role.id === this.activeRoleID)[0]
        .name;
    }
    return " ";
  }

  public getMode(): number {
    return this.mode;
  }

  public getOwnerID(): number {
    return this.ownerID;
  }

  public getOwnerDesignerID(): string {
    return this.ownerDesignerID;
  }

  public getOwnerKey(): string {
    return this.ownerKey;
  }

  public getOwnerName() {
    let name = this.getLoggedInOwnerName();

    if (name == null) {
      name = this.instanceOwnerName;
    }

    return name;
  }

  public getPageSizeOptions() {
    return this.pageSizeOptions;
  }

  public getParent() {
    return this.parent;
  }

  public getProgress(processGUID: string): Promise<Progress> {
    return this.http.get<Progress>(`progress/${processGUID}`).toPromise();
  }

  public getRequestOptions() {
    const requestOptions = {
      params: new HttpParams(),
    };

    requestOptions.params.append(
      "Content-Type",
      "application/json; charset=utf-8",
    );
    requestOptions.params.append("Authorization", "key " + this.ownerKey);
    requestOptions.params.append("System", this.system);
    requestOptions.params.append("UserName", this.ownerName);

    return requestOptions;
  }

  public getResetPasswordToken(): string {
    return this.resetPasswordToken;
  }

  public getRespondentExternalID() {
    return this.respondentExternalID;
  }

  public getRoleForExternalType(
    externalTypeID: number,
    externalTable: string,
  ): number {
    let roleID = 0;
    switch (externalTypeID) {
      case 4: // CAPAdmin
        roleID = 2; // SU
        break;
      case 3: // Administrator
        roleID = 3; // Admin
        break;
      case 2: // StandardUser
        roleID = 4; // User
        break;
      case 1:
        roleID = 5; // Read Only
        break;
    }
    return roleID;
  }

  public getSessionID(): number {
    if (this.ownerKey) {
      if (this.ownerKey.indexOf(".") > -1) {
        const sessionID = parseInt(this.ownerKey.split(".")[0]);
        // this.log(`getSessionID()... returning sessionID=${sessionID}`);
        return sessionID;
      } else {
        // this.log(`getSessionID()... returning ownerKey=${this.ownerKey}`);
        return parseInt(this.ownerKey);
      }
    }
    // this.log('getSessionID()... returning null.');
    return null;
  }

  public getShowItem(item): boolean {
    return this.showItems.indexOf(item) > -1;
  }

  public getShowLogin(): boolean {
    return this.showLogin;
  }

  public getStandalone(): boolean {
    return this.standalone;
  }

  public getSystem(): string {
    return this.system;
  }

  public getTargetID(): number {
    return this.targetID;
  }

  public getTargetName() {
    return this.termsMode === 0
      ? this.termsMode0["Target"]
      : this.termsMode1["Target"];
  }

  public handleError(
    error: any,
    title: string = null,
    writeToDB: boolean = true,
  ) {
    const source = "AdminUI";
    const newline = "<br>";

    let message = "";

    if (error.message && typeof error.message === "string") {
      message += error.message;
    }

    if (error._body) {
      message += error._body;
    }

    if (error.error && typeof error.error === "string") {
      message += newline + error.error;
    }

    if (error.error && error.error.Message) {
      message += newline + error.error.Message;
    }

    if (typeof error === "string") {
      message += newline + error;
    }

    if (error.statusText && error.status) {
      message += newline + "Status: " + error.status + " " + error.statusText;
    }

    if (error.url) {
      message += newline + "[" + error.url + "]";
    }

    message = message.trim();
    if (message.startsWith(newline)) {
      message = message.substring(newline.length);
    }

    message = this.sanitize(message);
    title = this.sanitize(title);

    const dumbToast = !this.isAllowDebug();
    if (dumbToast) {
      this.toastr.error(
        "An error has occurred in the system.  Please try again.",
        "System Error",
      );
    } else {
      this.toastr.error(message, title);
    }

    message = `${message} [verboseToast=${!dumbToast}]`;
    console.error(`${source} ${title} ${message}`);

    if (writeToDB) {
      // var replace = "regex";
      const re = new RegExp(newline, "g");
      message = message.replace(re, "; ");
      message = message.startsWith(";") ? message.substring(1).trim() : message;

      if (this.isConnected()) {
        this.logError(source, title, message);
      } else {
        this.addLocalError(source, title, message);
      }
    }
  }

  public addLocalError(source: string, title: string, message: string) {
    let errorQueue = [];

    let error: { [k: string]: any } = {};
    error.Source = "AdminUI";
    error.Title = title;
    error.Message = message;

    var queueID = this.getLocalErrorQueueID();
    var existingQueue = localStorage.getItem(queueID);

    if (existingQueue) {
      errorQueue = [error, ...JSON.parse(existingQueue)];
    } else {
      errorQueue = [error];
    }

    localStorage.setItem(queueID, JSON.stringify(errorQueue));
  }

  public addLocalResponse(datasetDatapoint: DatasetDatapoint) {
    let responseQueue = [];

    let response: { [k: string]: any } = {};
    response.DatasetID = this.getActiveDatasetID();
    response.Iteration = this.getActiveDatasetIteration();
    response.DatapointTargetID = datasetDatapoint.datapointTargetID;
    response.GroupByValueIndex = datasetDatapoint.groupByValueIndex;
    response.ValueText = datasetDatapoint.valueText;

    var queueID = this.getLocalResponseQueueID();
    var existingQueue = localStorage.getItem(queueID);

    if (existingQueue) {
      var existingQueueObj = JSON.parse(existingQueue);
      var existingQueueObj = existingQueueObj.filter(
        (eq) =>
          !(
            eq.DatasetID == response.DatasetID &&
            eq.Iteration == response.Iteration &&
            eq.DatapointTargetID == response.DatapointTargetID &&
            eq.Iteration == response.Iteration
          ),
      );
      responseQueue = [response, ...existingQueueObj];
    } else {
      responseQueue = [response];
    }

    localStorage.setItem(queueID, JSON.stringify(responseQueue));
  }

  public handleInfo(message, title = null, messageOnly = false) {
    message = this.sanitize(message);
    title = this.sanitize(title);

    this.toastr.info(message, title);
    if (messageOnly) {
      this.logAction(title, message);
    }
  }

  public showSave(message: string = "Saving...", displaySeconds: number = 0) {
    this.saveToastID = this.toastr.info(message, null, {
      positionClass: "toast-bottom-right",
      closeButton: displaySeconds > 0 ? true : false,
      extendedTimeOut: 0,
      timeOut: displaySeconds * 1000,
      tapToDismiss: displaySeconds > 0 ? true : false,
    }).toastId;
  }

  public hideSave() {
    this.toastr.clear(this.saveToastID);
  }

  public handleSuccess(message, title = null) {
    message = this.sanitize(message);
    title = this.sanitize(title);

    this.toastr.success(message, title);
    this.logAction(title, message);
  }

  public handleWarning(message, title = null, log: boolean = true) {
    message = this.sanitize(message);
    title = this.sanitize(title);

    this.toastr.warning(message, title);

    if (log) {
      this.logAction(title, message);
    }
  }

  public initFeatureSet(url: string = null): Promise<FeatureSet> {
    let ownerKey = "0.0";
    // let ownerID = 0;
    // let authKey = null;

    if (url) {
      const ownerKeySegs = url.split("k=");
      if (ownerKeySegs.length > 1) {
        const ownerKeySeg = ownerKeySegs[1];
        let endIndex = ownerKeySeg.length;
        const ampIndex = ownerKeySeg.indexOf("&");
        if (ampIndex > -1) {
          endIndex = ampIndex;
        }
        ownerKey = ownerKeySeg.substring(0, endIndex);
        this.setOwnerKey(ownerKey);
      }
    }

    const ownerID = this.getOwnerID() !== undefined ? this.getOwnerID() : 0;
    const authKey = this.getAuthKey() !== undefined ? this.getAuthKey() : null;
    let respondentRoleID = 0;
    let respondentID = 0;

    // TODO: should be mapped in DB based on external system
    // (below is hard-coded for CCS)
    if (authKey && authKey.respondent) {
      const externalTypeID = authKey.respondent.externalTypeID;
      respondentRoleID = this.getRoleForExternalType(
        externalTypeID,
        authKey.respondent.externalSourceTable,
      );

      // TODO: Is this the right place to do this?
      if (respondentRoleID > 0) {
        this.setActiveRoleID(respondentRoleID);
      }

      respondentID = authKey.respondent.id;
    }

    var path = `app/featureset/${ownerID}/${respondentID}/${ownerKey}/${this.getStandalone()}`;
    if (this.isSimple()) {
      path += "?simple=true";
    }

    return this.http.get<FeatureSet>(path).toPromise();
  }

  public isAllowConsoleLog(): boolean {
    return this.allowConsoleLog;
  }

  public isAllowDebug(): boolean {
    return this.allowDebug;
  }

  public isConnected(): boolean {
    return this.getConnected() != false;
  }

  public isDebug(): boolean {
    return this.debug;
  }

  /*
  public isLocalDev(): boolean {
    return window.top.location.port === "4200";
  }*/

  public isReadOnly(): boolean {
    // TODO JCD: No hard-coding
    return this.activeRoleID === 5;
  }

  public isSimple(): boolean {
    return this.simple;
  }

  public isSupplierPortalV2Enabled(): boolean {
    return this.supplierPortalV2Enabled;
  }

  public isModulesV2Enabled(): boolean {
    return this.modulesV2Enabled;
  }

  public isSuperUser(): boolean {
    if (this.roleList) {
      const suRoleID = this.roleList.filter((role) => role.code === "SU")[0].id;
      return this.activeRoleID === suRoleID;
    }
    return false;
  }

  public loadFeatureSet(url: string = null) {
    if (this.featuresLoading === false && this.featureSetLoaded === false) {
      this.featuresLoading = true;

      this.initFeatureSet(url)
        .then((featureSet) => {
          this.featureSet = featureSet;
          if (this.featureSet.features.length > 0) {
            this.ownerID = this.featureSet.features[0].ownerID;
            this.ownerDesignerID = this.featureSet.features[0].ownerDesignerID;
          }
          this.featuresLoading = false;
          this.featureSetLoaded = true;
        })
        .catch((err) => {
          this.featuresLoading = false;
        });
    }
  }

  public loadGlobals(s: string): string {
    s = s
      .replace(/{ApiUrl}/g, this.getApiUrl())
      .replace(/{System}/g, this.getSystem())
      .replace(
        /{RespondentExternalID}/g,
        this.getRespondentExternalID().toString(),
      )
      .replace(/{AuthKey}/g, this.getAuthKey().key);

    return s;
  }

  public log(message: string) {
    if (this.isAllowConsoleLog()) {
      //if (message.indexOf('cewm:') === -1) {
      console.log(`[CapEngines] ${message}`);
      //}
    }
  }

  public logAction(action: string, message: string) {
    if (this.connected) {
      if (action === null) {
        action = "UI Action";
      }

      const actionLog = new ActionLog();
      actionLog.action = action;
      actionLog.message = message;
      actionLog.ownerID = this.getOwnerID();
      actionLog.respondentID = this.respondentID;

      const body = JSON.stringify(actionLog);

      this.http
        .post<ActionLog>("logging/action", body)
        .toPromise()
        .then((a) => {
          this.log("actionLog posted: " + a.id);
        })
        .catch((err) => {
          this.log(`Could not log action ${action}; ${message}.`);
        });
    } else {
      this.log(`No connection. Could not log action ${action}; ${message}.`);
    }
  }

  public logError(source: string, type: string, message: string) {
    if (this.connected) {
      const errorLog = new ErrorLog();
      errorLog.source = source;
      errorLog.type = type ? type : " ";
      errorLog.message = message;
      errorLog.ownerID = this.getOwnerID();
      errorLog.respondentID = this.respondentID ? this.respondentID : null;

      const body = JSON.stringify(errorLog);

      this.http
        .post<ErrorLog>("logging/error", body)
        .toPromise()
        .then((e) => {
          this.log("errorLog posted: " + e.id);
        })
        .catch((err) => {
          // do not log that we could not log...
          this.log(`Could not log error ${source}; ${type}; ${message}.`);
        });
    } else {
      this.log(
        `No connection. Could not log error ${source}; ${type}; ${message}.`,
      );
    }
  }

  public logoutUI() {
    this.log("logout");

    this.activeDatasetID = null;
    this.activeRespondentID = null;
    this.activeTargetID = null;
    this.unloadFeatures();
    this.setOwnerID(null);
    this.setOwnerDesignerID(null);
    this.setLoggedInOwnerName(null);
    this.setActiveRoleID(null);
    this.setAdminUILogin(false);
  }

  public externalLogin() {
    this.featureSet.linkData.requiresPassword = false;
  }

  // uuidv4
  public newGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        // tslint:disable-next-line: no-bitwise
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }

  public scrollTo(id: string) {
    console.log(`globalsService.scrollTo(${id})`);
    let el = document.getElementById(id);
    el.scrollIntoView();
  }

  public soloPage(page: string) {
    console.log(`globalsService.soloPage(${page})`);
    let elements = document.querySelectorAll(
      "div[class*='page-']",
    ) as NodeListOf<HTMLElement>;
    elements.forEach((p) => {
      if (!p.classList.contains(`page-${page}`)) {
        p.setAttribute("style", "display:none !important");
      }
    });
  }

  // {"page":"Detail","reportMode":0}
  public setActiveDashboardID(
    activeDashboardID: number,
    suppressBroadcast: boolean = false,
  ) {
    if (this.activeDashboardID === activeDashboardID) return;

    if (activeDashboardID === undefined) {
      activeDashboardID = null;
    }
    this.activeDashboardID = activeDashboardID;

    if (suppressBroadcast === false && this.hasReBroadcastPermission()) {
      const data = JSON.stringify({ dashboardID: this.activeDashboardID });
      this.broadcast(data);
    }
  }

  public setActiveDatasetID(activeDatasetID: number) {
    this.activeDatasetID = activeDatasetID;
  }

  public setActiveDatasetIteration(activeDatasetIteration: number) {
    this.activeDatasetIteration = activeDatasetIteration;
  }

  public setActiveRespondentID(activeRespondentID: number) {
    this.activeRespondentID = activeRespondentID;
  }

  public setActiveRoleID(activeRoleID: number) {
    this.activeRoleID = activeRoleID;
  }

  public setActiveTargetID(activeTargetID: number) {
    this.activeTargetID = activeTargetID;
  }

  public setActiveBulkTargetID(activeBulkTargetID: string) {
    this.activeBulkTargetID = activeBulkTargetID;
  }

  public setActiveBulkTargetValueID(activeBulkTargetValueID: number) {
    this.activeBulkTargetValueID = activeBulkTargetValueID;
  }

  public setAdminUILogin(adminUILogin: boolean) {
    this.adminUILogin = adminUILogin;
  }

  public setAuthKey(authKey: AuthKey) {
    this.authKey = authKey;
  }

  public setCCSFrom(ccsFrom: string) {
    this.ccsFrom = ccsFrom;
  }

  public setConnected(connected: boolean) {
    this.connected = connected;
    if (connected === false) {
      this.connectionLost = new Date();
    } else {
      this.logAction(
        "Connection Restored",
        `lost: ${this.datepipe.transform(this.connectionLost, "yyyy-MM-dd h:mm:ss", "UTC")}; ` +
          `restored: ${this.datepipe.transform(new Date(), "yyyy-MM-dd h:mm:ss", "UTC")}; ` +
          `reid: ${this.getRespondentExternalID()}; ` +
          `rid: ${this.getActiveRespondentID()}; ` +
          `tid: ${this.getActiveTargetID()}; `,
      );
      this.connectionLost = null;
    }
  }

  public setCustomMenuState(
    elRef: ElementRef,
    page: string,
    reportMode: number,
    dashboardID: number,
    source: string = null,
  ) {
    const toggleClassElements = elRef.nativeElement.querySelectorAll(
      ".style-background-toggle",
    ) as HTMLElement[];

    if (toggleClassElements.length > 0) {
      this.log(
        `setCustomMenuState: ENTER [page=${page}; reportMode=${reportMode}; dashboardID=${dashboardID}; activeDashboardID=${this.getActiveDashboardID()}; source: ${source}].`,
      );

      if (dashboardID != null) {
        // reportMode 3: SiteDetails

        this.log(`setCustomMenuState: APPLY [dashboardID=${dashboardID}].`);

        // highlight / de-highlight menu button elements as warranted, based on colors specified in their
        // attributes
        toggleClassElements.forEach((element) => {
          let elementName = "";
          const elementNameNode = element.attributes["name"];
          if (elementNameNode) {
            elementName = elementNameNode.nodeValue;
          }

          var logPrefix = `setCustomMenuState: ${elementName}`.trim();

          let elementDashboardID = null;
          const dashboardIdNode = element.attributes["dashboardid"];
          if (dashboardIdNode) {
            elementDashboardID = parseInt(dashboardIdNode.nodeValue);
            this.log(`${logPrefix} elementDashboardID=${elementDashboardID}`);
          }

          const currentBackground = element.style.background;
          const toggleBackground =
            element.attributes["toggleBackgroundColor"].nodeValue;
          const toggleColor = element.attributes["toggleColor"].nodeValue;
          const defaultBackground =
            element.attributes["defaultBackgroundColor"].nodeValue;
          const defaultColor = element.attributes["defaultColor"].nodeValue;

          this.log(
            `${logPrefix} currentBackground=${currentBackground}; toggleBackground=${toggleBackground};`,
          );

          if (reportMode === 3) {
            // reportMode 3: Site Details
            // highlight the selected dashboard
            if (elementDashboardID === dashboardID) {
              this.log(
                `${logPrefix} set element for dashboardID=${dashboardID} to TOGGLE colors [color=${toggleColor}; background=${toggleBackground};`,
              );
              element.style.cssText = `background: ${toggleBackground} !important; color: ${toggleColor} !important`;
            } else {
              // de-highlight the rest
              this.log(
                `${logPrefix} set element for dashboardID=${dashboardID} to DEFAULT colors [color=${defaultColor}; background=${defaultBackground};`,
              );
              element.style.cssText = `background: ${defaultBackground} !important; color: ${defaultColor} !important`;
            }
          } else {
            // not Site Details
            // de-highlight all
            this.log(
              `${logPrefix} set element for dashboardID=${dashboardID} to DEFAULT colors [color=${defaultColor}; background=${defaultBackground};`,
            );
            element.style.cssText = `background: ${defaultBackground} !important; color: ${defaultColor} !important`;
          }
        });
      } else if (page != null && reportMode != null) {
        this.log(
          `setCustomMenuState: APPLY [page=${page}; reportMode=${reportMode}]`,
        );

        toggleClassElements.forEach((element) => {
          let elementName = "";
          const elementNameNode = element.attributes["name"];
          if (elementNameNode) {
            elementName = elementNameNode.nodeValue;
          }

          let elementDashboardID = null;
          const dashboardIdNode = element.attributes["dashboardid"];
          if (dashboardIdNode) {
            elementDashboardID = parseInt(dashboardIdNode.nodeValue);
          }

          var logPrefix = `setCustomMenuState: ${elementName}`.trim();

          const currentBackground = element.style.background;
          const toggleBackground =
            element.attributes["toggleBackgroundColor"].nodeValue;
          const toggleColor = element.attributes["toggleColor"].nodeValue;

          const defaultBackground =
            element.attributes["defaultBackgroundColor"].nodeValue;
          const defaultColor = element.attributes["defaultColor"].nodeValue;
          this.log(
            `${logPrefix} currentBackground=${currentBackground}; toggleBackground=${toggleBackground};`,
          );

          if (page === "Detail" && reportMode == 3) {
            // we've just navigated to SiteDetails
            this.log(
              `${logPrefix} [currentBackground=${currentBackground}; color=${toggleColor}; ` +
                `background=${toggleBackground}; defaultBackground=${defaultBackground}; defaultColor=${defaultColor}`,
            );

            if (elementDashboardID === null) {
              // we're here if no dashboardID came through on the windows message,
              // so leave elements with a dashboardID as found.

              element.style.cssText = `background: ${toggleBackground} !important; color: ${toggleColor} !important`;
              element.style.background = toggleBackground;
              element.style.color = toggleColor;
            }
          } else {
            this.log(
              `${logPrefix} set element to default colors [color=${defaultColor}; background=${defaultBackground};`,
            );
            element.style.cssText = `background: ${defaultBackground} !important; color: ${defaultColor} !important`;
            element.style.background = defaultBackground;
            element.style.color = defaultColor;
          }
        });
      }
    }
  }

  public setDebug(debug: boolean) {
    this.debug = debug;
  }

  public setDatasetExternalID(datasetExternalID: number) {
    if (
      datasetExternalID !== this.datasetExternalID &&
      datasetExternalID !== undefined
    ) {
      this.datasetExternalID = datasetExternalID;

      if (this.hasReBroadcastPermission()) {
        const data = JSON.stringify({
          datasetExternalID: this.datasetExternalID,
        });
        this.broadcast(data);
      }
    }
  }

  public setFeatureSet(featureSet: FeatureSet) {
    this.featureSet = featureSet;
  }

  public setLinkData(linkData: LinkData) {
    this.linkData = linkData;
  }

  public setFeatureSetLoaded(featuresLoaded: boolean) {
    this.featureSetLoaded = featuresLoaded;
  }

  public setGlobalPreview(globalPreview: boolean) {
    this.globalPreview = globalPreview;
  }

  public setHideMenu(hideMenu: boolean) {
    this.hideMenu = hideMenu;
  }

  public setImpersonationMode(impersonationMode: number) {
    this.impersonationMode = impersonationMode;
  }

  public setIsBulk(isBulk: boolean) {
    this.isBulk = isBulk;
  }

  public setJWT(jwt: string) {
    this.jwt = jwt;
  }

  public setLibraryPreview(libraryPreview: boolean) {
    this.libraryPreview = libraryPreview;
  }

  public setLoggedInOwnerName(loggedInOwnerName: string) {
    this.loggedInOwnerName = loggedInOwnerName;
  }

  public setMaintenance(maintenance: boolean) {
    this.maintenance = maintenance;
  }

  public setMaintenanceHtml(maintenanceHtml: string) {
    this.maintenanceHtml = maintenanceHtml;
  }

  public setMode(mode: number) {
    this.mode = mode;
    this.log("setMode: " + this.mode);
  }

  public setOwnerID(ownerID: number) {
    this.ownerID = ownerID;
  }

  public setOwnerDesignerID(ownerDesignerID: string) {
    this.ownerDesignerID = ownerDesignerID;
  }

  public setOwnerKey(ownerKey: string) {
    this.ownerKey = ownerKey;
  }

  public setParent(parent: string) {
    this.parent = parent;
  }

  public setResetPasswordToken(resetPasswordToken: string) {
    this.resetPasswordToken = resetPasswordToken;
  }

  public setRespondentExternalID(respondentExternalID: number) {
    this.respondentExternalID = respondentExternalID;
  }

  public setRoleList(roleList: Role[]) {
    this.roleList = roleList;
  }

  public setShowItems(showItems: string[]) {
    this.showItems = showItems;
  }

  public setShowLogin(showLogin: boolean) {
    this.showLogin = showLogin;
  }

  public setSimple(simple: boolean) {
    this.simple = simple;
    if (this.simple == false) {
      this.termsMode = this.TERMS_MODE_DEFAULT;
    } else {
      this.termsMode = this.TERMS_MODE_SIMPLE;
    }
  }

  public setStandalone(standalone: boolean) {
    this.standalone = standalone;
  }

  public termTranslate(term: string, termsMode: number = undefined): string {
    let newTerm: string = term;

    if (termsMode === undefined) {
      termsMode = this.termsMode;
    }
    const m = termsMode === 0 ? this.termsMode0 : this.termsMode1;

    for (const key in m) {
      if (!term.includes(key)) {
        continue;
      }
      const replacementString = m[key];
      newTerm = newTerm.replace(key, replacementString);
    }

    return newTerm;
  }

  public truncate(str: string, len: number): string {
    if (str.length < len) {
      return str;
    } else {
      return str.substr(0, len) + "...";
    }
  }

  public getLocalResponseQueueID(): string {
    return `cmlocal-responses.${this.getSystem().toLowerCase()}`;
  }

  public getLocalErrorQueueID(): string {
    return `cmlocal-errors.${this.getSystem().toLowerCase()}`;
  }

  public updateQueryParams(
    router: Router,
    paramKey: string,
    paramValue: string,
    addIfNotExists: boolean,
  ) {
    const params = {};
    params[paramKey] = paramValue;

    let url: string = router.url;

    if (addIfNotExists || router.url.indexOf(`${paramKey}=`) > -1) {
      url = router
        .createUrlTree([], {
          queryParams: params,
          queryParamsHandling: "merge",
          preserveFragment: true,
        })
        .toString();
    }

    return url;
  }

  public uploadLocalResponses() {
    localStorage.removeItem(this.getLocalResponseQueueID());
  }

  public uploadLocalErrors() {
    localStorage.removeItem(this.getLocalErrorQueueID());
  }

  public upsertSessionVariable(name: string, value: string): Promise<number> {
    return this.http
      .post<number>(
        `session/variable?name=${name}&value=${value}` +
          `&datasetExternalID=${this.getDatasetExternalID()}` +
          `&datasetID=${this.getActiveDatasetID()}&iteration=${this.getActiveDatasetIteration()}`,
        null,
      )
      .toPromise();
  }

  private getBoolean(value: any): boolean {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  private sanitize(s: string) {
    if (s == null) {
      return null;
    } else if (
      (s.indexOf("password") > -1 &&
        s.indexOf("reset") < 0 &&
        s.indexOf("must have") < 0) ||
      s.indexOf("pwd") > -1
    ) {
      return "Error submitting credentials.";
    } else {
      return s;
    }
  }

  private unloadFeatures() {
    this.featuresLoading = false;
    this.featureSetLoaded = false;
    this.featureSet = null;
  }

  // notifications
  private eventChannels = {};
  private subscriptions$: Subscription[] = [];

  public sendEvent<T>(eventName: string, data: T) {
    this.registerEvent<T>(eventName);
    (this.eventChannels[eventName] as Subject<T>).next(data);
  }

  public subscribeEvent<T>(
    eventName: string,
    cb: (data: T) => any,
  ): Subscription {
    this.registerEvent<T>(eventName);
    let subscribe = this.eventChannels[eventName].subscribe(cb);
    this.subscriptions$.push(subscribe);
    return subscribe;
  }

  ngOnDestroy() {
    // _.forEach(this.eventChannels, (name, subject) => subject.complete());
    this.subscriptions$.forEach((sub) => sub.unsubscribe());
  }

  private registerEvent<T>(eventName: string) {
    if (!(eventName in this.eventChannels)) {
      this.eventChannels[eventName] = new Subject<T>();
    }
  }
}
